module.exports = require("moleculer-repl");